export const convertDotNotationToNested = (
    fields: Record<string, Array<Record<string, unknown>>>
): Record<string, Array<Record<string, unknown>>> => {
    return Object.entries(fields).reduce((acc, [key, value]) => {
        acc[key] = value.map((item) => {
            const nestedObject: Record<string, unknown> = {};
            Object.entries(item).forEach(([fieldKey, fieldValue]) => {
                const keys = fieldKey.split('.');
                keys.reduce((obj, part, index) => {
                    if (index === keys.length - 1) {
                        obj[part] = fieldValue;
                    } else {
                        obj[part] = obj[part] || {};
                    }
                    return obj[part] as Record<string, unknown>;
                }, nestedObject);
            });
            return nestedObject;
        });
        return acc;
    }, {} as Record<string, Array<Record<string, unknown>>>);
};

export const convertNestedToDotNotation = (
    fields: Record<string, Array<Record<string, unknown>>>
): Record<string, Array<Record<string, unknown>>> => {
    function flattenObject(
        obj: Record<string, any>,
        parentKey = '',
        result: Record<string, unknown> = {}
    ): Record<string, unknown> {
        Object.entries(obj).forEach(([key, value]) => {
            const fullKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                flattenObject(value, fullKey, result);
            } else {
                result[fullKey] = value;
            }
        });
        return result;
    }

    return Object.entries(fields).reduce((acc, [key, value]) => {
        acc[key] = value.map((item) => flattenObject(item));
        return acc;
    }, {} as Record<string, Array<Record<string, unknown>>>);
};
